import { RouteRecordRaw } from "vue-router";

// router needs a default route
export const defaultroutes: Array<RouteRecordRaw> = [
  // if you need you can put here a default route
];
